import { DependencyList, EffectCallback, useEffect, useRef } from 'react'

export default (effect: EffectCallback, deps?: DependencyList): void => {
    const isInitialMount = useRef(true)

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false
        } else {
            return effect()
        }
    }, deps)
}
